import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';

const GeneralSettings = () => {

  const isMounted = useRef(false);


  useEffect(() => {
    if (isMounted.current) return;

    isMounted.current = true;
  }, []);

  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {/* <div className=""> */}
        {/* <Header logo_url='/ULDForwarder/ActiveTrips' /> */}
        {/* <Header logo_url={SBack ? SBack : '/ULDForwarder/ActiveTrips'} sBackUrl={SBack ? SBack : '/ULDForwarder/ActiveTrips'} />
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel">
            <div className="row">

              <LeftSettings /> */}
              <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right'>
                  <h4>General Settings</h4>
                  <p>Set your notification preferences for when you are in or away from the dashboard.</p>
                  <hr />
                  <div className='d-flex align-items-center'>
                    

                  </div>
                </div>
              </div>
            {/* </div>

          </div>
        </div>
      </div> */}
    </>
  )
}

export default GeneralSettings;

